<template>
  <div>
    <v-navigation-drawer
      color="black"
      v-model="appDrawer"
      fixed
      temporary>
      <v-list>
        <v-list-item
          v-for="item in mainNavigation"
          :key="item.name"
          link
          :to="{name: item.page}">
          <v-list-item-content>
            <v-list-item-title class="title">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="black"
      id="mainNav"
      flat>
      <v-container class="px-0 py-0">
        <div class="d-flex align-center">
        <v-app-bar-nav-icon
          class="d-block d-sm-none"
          @click.stop="appDrawer = !appDrawer">
        </v-app-bar-nav-icon>
          <router-link
            :to="{ name: 'Home' }"
            class="mr-4">
            <v-img
              class="d-none d-sm-block"
              max-width="148px"
              :src="require(`@/assets/jindocoin-logotype.svg`)"
              alt="logo">
            </v-img>
            <v-img
              class="d-sm-none"
              max-width="48px"
              :src="require(`@/assets/jindocoin-icon.svg`)"
              aspect-ratio="1"
              alt="logo">
            </v-img>
          </router-link>
          <template v-for="(item, index) in mainNavigation">
            <v-btn
              :to="{ name: item.page }"
              :key="index"
              class="mr-4"
              :class="[item.hide ? 'd-none' : 'd-none d-sm-flex']"
              rounded
              text>
              <!-- //d-none d-md-block -->
              {{item.title}}
            </v-btn>
          </template>
          <v-spacer />
          <v-btn
            v-for="item in socialIcons"
            :key="item.name"
            @click="clickUrl(item.link)"
            class="mr-4"
            icon
            small>
            <v-img
              max-width="18px"
              :src="require(`@/assets/social/icons/${item.icon}`)"
              :alt="item.name" aspect-ratio="1">
            </v-img>
          </v-btn>
          <telegram-menu />
          <v-btn
            rounded color="primary"
            class="black--text"
            disabled
            @click="getJindoBuyDialog()">
            <span class="mr-md-1">Soon</span> <!-- Buy -->
            <span class="d-none d-md-block"><!-- $Jindo --></span>
          </v-btn>
        </div>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
const TelegramMenu = () => import(/* webpackChunkName: "TelegramMenu" */ '@/components/menu/TelegramMenu.vue')

export default {
  components: {
    'telegram-menu': TelegramMenu
  },

  data: () => ({
    appDrawer: false,
    mainNavigation: [
      // { title: 'About', page: 'About', hide: false },
      // { title: 'Roadmap', page: 'Roadmap', hide: false },
      { title: 'Press kit', page: 'Press', hide: true }
      // { title: 'Donate', page: 'Donate', hide: false }
      // { title: 'Menifesto', page: 'Menifesto', hide: true }
    ],
    socialIcons: [
      {
        name: 'tiwtter',
        icon: 'twitter-icon.svg',
        link: 'https://twitter.com/jindocoin'
      }
      // {
      //   name: 'reddit',
      //   icon: 'reddit-icon.svg',
      //   link: 'https://www.reddit.com/r/jindocoin'
      // }
    ]
  }),
  watch: {
    hideDrawer (value) {
      if (!value) this.appDrawer = false
    }
  },
  computed: {
    hideDrawer () {
      return !this.$vuetify.breakpoint.mdAndUp
    }
  },
  methods: {
    getJindoBuyDialog () {
      console.log('Comming soon')
      // this.$store.dispatch('getJindoBuyDialogAction', {
      //   value: true
      // })
      // if (this.$route.query.buyjindo !== 'true') {
      //   this.$router.replace({ query: { buyjindo: true } })
      // }
    },
    clickUrl (value) {
      window.open(value, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  #mainNav ::v-deep .v-toolbar__content {
    padding: 0 8px !important;
  }
</style>
